<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
    <section class="pt-[60px] pb-[40px] sm:pt-24 sm:pb-12">
        <UContainer>
            <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                <h1 class="uppercase text-[#148744] text-[30px] leading-[38px] sm:text-[46px] sm:leading-[48px]">{{ t('myStory.title') }}</h1>
            </div>
        </UContainer>
    </section>
</template>

<style scoped>

</style>
